<template>
  <div class="container mb-5">
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Accumulative Return</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="accumulative-return"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="accumulative-return" triggers="hover">
                    Calculated by adding the returns from all trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_accumulative_return }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Account Balance</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="account-balance"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="account-balance" triggers="hover">
                    Accumulative Return + Account Balance (user input)
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_account_balance }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg Daily Return</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_daily_return"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_daily_return" triggers="hover">
                    Average from all the return from all the trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_avg_daily_return }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Return on Longs</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="return_on_longs"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="return_on_longs" triggers="hover">
                    Adding all the “LONG” returns from the main page
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_return_on_longs }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Return on Shorts</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="return_on_shorts"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="return_on_shorts" triggers="hover">
                    Adding all the “SHORT” returns from the main page
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_return_on_shorts }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Return on Puts</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="return_on_puts"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="return_on_puts" triggers="hover">
                    Adding all the “PUT” returns from the main page
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_return_on_puts }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Return on Calls</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="return_on_calls"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="return_on_calls" triggers="hover">
                    Adding all the “CALL”returns from the main page
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_return_on_calls }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Profit/Loss Ratio</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="profit_loss_ratio"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="profit_loss_ratio" triggers="hover">
                    Dividing the Return on Winners by the Return on Losers
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_profit_loss_ratio }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Accumulative Return %</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="accumulative_return_per"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="accumulative_return_per" triggers="hover">
                    Dividing the initial account value (input for user to enter) by the Accumulative Return $
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_accumulative_return_per }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Return</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_return"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_return" triggers="hover">
                    Taking all the trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_return }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Long</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_Long"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_Long" triggers="hover">
                    Taking all the long trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_Long }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Short</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_short"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_short" triggers="hover">
                    Taking all the short trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_short }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Calls</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_calls"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_calls" triggers="hover">
                     Taking all the Call trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_calls }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Puts</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_puts"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_puts" triggers="hover">
                    Taking all the puts trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_puts }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Total Trades</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="total_trades"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="total_trades" triggers="hover">
                    Number of all the trades closed
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_total_trades }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Trades Per Day</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="trades_per_day"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="trades_per_day" triggers="hover">
                    Average number of trades per day that are closed
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_trades_per_day }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg % Return on Monday</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_per_return_monday"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_per_return_monday" triggers="hover">
                    Taking all the trades from every monday and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_per_return_monday }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
           <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg % Return on Tuesday</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_per_return_tuesday"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_per_return_tuesday" triggers="hover">
                    Taking all the trades from every Tuesday and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_per_return_tuesday }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg % Return on Wednesday</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_per_return_wednesday"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_per_return_wednesday" triggers="hover">
                    Taking all the trades from every Wednesday and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_per_return_wednesday }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg % Return on Thursday</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_per_return_thursday"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_per_return_thursday" triggers="hover">
                    Taking all the trades from every Thursday and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_per_return_thursday }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
           <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg % Return on Friday</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_per_return_friday"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_per_return_friday" triggers="hover">
                    Taking all the trades from every Friday and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_per_return_friday }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
           <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg Position Size</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_position_size"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_position_size" triggers="hover">
                     Dividing the initial amount of the trade by the account size that day
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_position_size }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "OverviewChart",
  props: {
    data: {
      type: Array,
    },
    total_fund: {
      type: Number,
    },
  },
  data() {
    return {
      accumulative_return: 0,
    };
  },
  computed: {
    get_accumulative_return() {
      let filter_return = this.data.filter((item) =>{
        return item.return > 0
      })
      let accumulative_return = filter_return.reduce((acc, currentValue) =>{
        return acc + parseFloat(currentValue['return'])
      },0)
      return accumulative_return.toFixed(2);
    },
    get_account_balance() {
      let balance =
        parseFloat(this.get_accumulative_return) + parseFloat(this.total_fund);
      return balance.toFixed(2);
    },
    get_avg_daily_return() {
      let accumulative_return = parseFloat(this.get_accumulative_return);
      let counts = this.data.length;

      return (accumulative_return / counts).toFixed(2);
    },
    get_return_on_longs() {
      let total_fund = 0;
      this.data.forEach((ele) => {
        if (ele["side"] === "Long" && !ele["is_open"]) {
          total_fund += ele["return"];
        }
      });
      return total_fund.toFixed(2);
    },
    get_return_on_shorts() {
      let total_fund = 0;
      this.data.forEach((ele) => {
        if (ele["side"] === "Short" && !ele["is_open"]) {
          total_fund += ele["return"];
        }
      });
      return total_fund.toFixed(2);
    },
    get_return_on_puts() {
      let total_fund = 0;
      this.data.forEach((ele) => {
        if (ele["direction"] === "Put" && !ele["is_open"]) {
          total_fund += ele["return"];
        }
      });
      return total_fund.toFixed(2);
    },
    get_return_on_calls() {
      let total_fund = 0;
      this.data.forEach((ele) => {
        if (ele["direction"] === "Call" && !ele["is_open"]) {
          total_fund += ele["return"];
        }
      });
      return total_fund.toFixed(2);
    },
    get_profit_loss_ratio() {
      let winner_trade = 0;
      let losser_trade = 0;
      this.data.forEach((ele) => {
        if (ele["return"] > 0) {
          winner_trade += ele["return"];
        } else if (ele["return"] < 0){
          losser_trade += ele["return"];
        }
      });
      let ratio = winner_trade / losser_trade;
      return ratio.toFixed(2);
    },
    get_accumulative_return_per() {
      let total_return =
        parseFloat(this.total_fund) / parseFloat(this.get_accumulative_return);
      return total_return.toFixed(2);
    },
    get_average_per_return() {
      let accumulative_return_per = 0;
      let total_trade = 0;
      this.data.forEach((ele) => {
        if (!ele["is_open"]) {
          accumulative_return_per += ele["return_per"];
          total_trade += 1;
        }
      });
      let percent = accumulative_return_per / total_trade;
      return percent.toFixed(2);
    },
    get_average_per_Long() {
      let total_fund = 0;
      let count = 0;
      this.data.forEach((ele) => {
        if (ele["side"] === "Long" && !ele["is_open"]) {
          total_fund += ele["return_per"];
          count += 1;
        }
      });
      let percent = total_fund / count;
      return percent.toFixed(2);
    },
    get_average_per_short() {
      let total_fund = 0;
      let count = 0;
      this.data.forEach((ele) => {
        if (ele["side"] === "Short" && !ele["is_open"]) {
          total_fund += ele["return_per"];
          count += 1;
        }
      });
      let percent = total_fund / count;
      return percent.toFixed(2);
    },
    get_average_per_calls() {
      let total_fund = 0;
      let count = 0;
      this.data.forEach((ele) => {
        if (ele["direction"] === "Call" && !ele["is_open"]) {
          total_fund += ele["return_per"];
          count += 1;
        }
      });
      let percent = total_fund / count;
      return percent.toFixed(2);
    },
    get_average_per_puts() {
      let total_fund = 0;
      let count = 0;
      this.data.forEach((ele) => {
        if (ele["direction"] === "Put" && !ele["is_open"]) {
          total_fund += ele["return_per"];
          count += 1;
        }
      });
      let percent = total_fund / count;
      return percent.toFixed(2);
    },
    get_total_trades() {
      let count = 0;
      this.data.forEach((ele) => {
        if (!ele["is_open"]) {
          count += 1;
        }
      });
      return count;
    },
    get_trades_per_day() {
      var sums = this.data.reduce(function (acc, obj) {
        var date = obj.date
        if (!acc[date]) {
          acc[date] = { count: 0 };
        }
        acc[date].count++;
        return acc;
      }, Object.create(null));

      let total_counts = 0;
      let total_days = 0;

      Object.keys(sums).map(function (date) {
        total_days += 1
        total_counts += sums[date].count
        return { [date]:sums[date].count };
      });

      let per_day = total_counts/total_days

      return per_day.toFixed(2)
    },
    get_avg_per_return_monday(){
      const matchItem = this.data.filter((item) =>{
        let day = new Date(item.date).getDay()
        return day === 1 && item.is_open === false
      });

      var total_return = matchItem.reduce(function(acc, obj){
        return acc + obj.return_per
      }, 0)

      var total_days = matchItem.map((obj) =>{
        return obj.return_per;  
      })
      let aver_return = total_return/total_days.length

      return aver_return.toFixed(2)
    },
    get_avg_per_return_tuesday(){
      const matchItem = this.data.filter((item) =>{
        let day = new Date(item.date).getDay()
        return day === 2 && item.is_open === false
      });

      var total_return = matchItem.reduce(function(acc, obj){
        return acc + obj.return_per
      }, 0)

      var total_days = matchItem.map((obj) =>{
        return obj.return_per;  
      })
      let aver_return = total_return/total_days.length

      return aver_return.toFixed(2)
    },
    get_avg_per_return_wednesday(){
      const matchItem = this.data.filter((item) =>{
        let day = new Date(item.date).getDay()
        return day === 3 && item.is_open === false
      });

      var total_return = matchItem.reduce(function(acc, obj){
        return acc + obj.return_per
      }, 0)

      var total_days = matchItem.map((obj) =>{
        return obj.return_per;  
      })
      let aver_return = total_return/total_days.length

      return aver_return.toFixed(2)
    },
    get_avg_per_return_thursday(){
      const matchItem = this.data.filter((item) =>{
        let day = new Date(item.date).getDay()
        return day === 4 && item.is_open === false
      });

      var total_return = matchItem.reduce(function(acc, obj){
        return acc + obj.return_per
      }, 0)

      var total_days = matchItem.map((obj) =>{
        return obj.return_per;  
      })
      let aver_return = total_return/total_days.length

      return aver_return.toFixed(2)
    },
    get_avg_per_return_friday(){
      const matchItem = this.data.filter((item) =>{
        let day = new Date(item.date).getDay()
        return day === 5 && item.is_open === false
      });

      var total_return = matchItem.reduce(function(acc, obj){
        return acc + obj.return_per
      }, 0)

      var total_days = matchItem.map((obj) =>{
        return obj.return_per;  
      })
      let aver_return = total_return/total_days.length

      return aver_return.toFixed(2)
    },
    get_avg_position_size(){
      var total_qty = this.data.reduce(function(acc, obj){
        return acc + obj.quantity
      }, 0)

      var total_trade = this.data.length
      var avg_trade = total_qty/total_trade

      return avg_trade.toFixed(2)
    }
  },
  async mounted() {
    if (this.data.length > 0) {
      console.log("Yes ", this.data);
    }
    // this.calAccReturnData()
    // const s = new dfd.Series([1,2,3,4,5])
    // s.print();
  },
  methods: {
    async calAccReturnData() {
      // this.data.forEach((ele) => {
      //   console.log("this.accumulative_return ", ele["return"])
      //   this.accumulative_return += ele["return"]
      // });
    },
  },
};
</script>

<style scoped>
.container {
  color: #f8f8f8;
}
</style>